import clsx from "clsx";

import styles from "./CalendarLegend.module.scss";
import BodyText from "../BodyText";

export type CalendarLegendProps = {
  highlightedDayLabel?: string;
};

export default function CalendarLegend({
  highlightedDayLabel,
}: CalendarLegendProps) {
  return (
    <div className={styles.legend}>
      {highlightedDayLabel && (
        <div className={styles.legendItem}>
          <div className={clsx(styles.marker, styles.highlighted)} />
          <BodyText color="body-1">{highlightedDayLabel}</BodyText>
        </div>
      )}
      <div className={styles.legendItem}>
        <div className={clsx(styles.marker, styles.today)} />
        <BodyText color="body-1">Today</BodyText>
      </div>
      <div className={styles.legendItem}>
        <div className={clsx(styles.marker, styles.selected)} />
        <BodyText color="body-1">Selected Date</BodyText>
      </div>
    </div>
  );
}
